<script setup lang="ts">
import { ref, toRefs, watchEffect } from 'vue';

import type { SymbolDTO } from '@nora-monorepo/nora-api-client';
import { appLogger } from '@nora-monorepo/ui-shared';

import { resolvePreviewTintColor, useSymbolStore } from '#nora-ui/stores/symbol-store';

interface Props {
  symbol: SymbolDTO;
  color?: string;
}

const props = defineProps<Props>();
const { symbol, color } = toRefs(props);

const symbolStore = useSymbolStore();

const imageUrl = ref<string>('');

watchEffect(async () => {
  try {
    imageUrl.value = await symbolStore.getSymbolObjectUrl(
      symbol.value.symbolPackId,
      symbol.value.id,
      color.value ?? resolvePreviewTintColor(),
    );
  }
  catch (error) {
    appLogger.warn({
      message: 'Symbol preview load failed',
      sensitiveContext: {
        symbolPackId: symbol.value.symbolPackId,
        symbolId: symbol.value.id,
        error: error instanceof Error ? { name: error.name, message: error.message } : { value: String(error) },
      },
    });
  }
});
</script>

<template>
  <img
    v-if="imageUrl"
    :src="imageUrl"
    class="max-w-full max-h-full"
    alt="Symbol"
  >
</template>
